import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { setBreadcrumb } from "../../slices/auth/menu/reducer";
import { useDispatch } from "react-redux";
import { getFeedSuccess, setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage } from "../../slices/feeds/reducer";
import { getAllLibrariesSuccess, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoading, setAllLibrariesPage } from "../../slices/campaigns/reducer";
import { resetTableFilter } from "../../slices/folder/thunk";

const BreadCrumb = ({ pageTitle, title }) => {
	const dispatch = useDispatch()

	function changeTitle(idx, item) {
		const updatedTitle = [];
		if (idx > 0) {
			let i = 0;
			do {
				if (title[i]) {
					updatedTitle.push(title[i]);
				}
				i++;
			} while (i < (idx + 1));
		} else {
			if (title.length === 1) {
				dispatch(setBreadcrumb({ pageTitle: pageTitle, title: [{ name: item.name, src: item.src }] }));
			} else {
				dispatch(setBreadcrumb({ pageTitle: pageTitle, title: [] }));
			}
		}
		dispatch(resetTableFilter());
		dispatch(setBreadcrumb({ pageTitle: pageTitle, title: updatedTitle }));
	}

	return (
		<React.Fragment>
			<Row>
				<Col xs={12}>
					<div className="d-sm-flex align-items-center justify-content-between">
						<div className="page-title-right">
							<ol className="breadcrumb m-0">
								{(title || []).map((item, idx) => {
									return (
										<li onClick={() => changeTitle(idx, item)} className={"breadcrumb-item" + (idx === (title.length - 1) ? ' active' : '')} key={idx}>
											<Link to={item?.src}>{item?.name}</Link>
										</li>
									)
								})}
								{/* <li className="breadcrumb-item">{pageTitle}</li>
								<li className="breadcrumb-item active"><Link to="#">{title}</Link></li> */}
							</ol>
						</div>
						{/* <h4 className="mb-sm-0 fw-normal">{pageTitle}</h4> */}
					</div>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default BreadCrumb;